import { selectCredentials } from '@views/loginView/state/loginSlice'
import { call, takeEvery, put, select } from 'redux-saga/effects'
import { getPrepayments, getPrepaymentsFailed, getPrepaymentsSuccess, PrepaymentResponse } from './prepaymentsSlice'
import { getPrepaymentsService } from '@http/prepaymentsService'

export function* prepaymentsHttp() {
  const { cocap } = yield select(selectCredentials)
  try {
    const prepayments: PrepaymentResponse = yield call(getPrepaymentsService, cocap)
    yield put(getPrepaymentsSuccess(prepayments))
  } catch (e) {
    yield put(getPrepaymentsFailed(JSON.stringify(e)))
  }
}

export default function* prepaymentsSaga() {
  yield takeEvery(getPrepayments.type, prepaymentsHttp)
}
